import { MockObjectItem, ObjectSemanticMappingResponse } from "@/types/semanticDataMap";
import { useApiQuery } from "@packages/api-client/src";

// OPM数据接口类型定义
export interface OntologyListType {
  data: MockObjectItem[];
}


// 获取本体可配置映射对象列表
export function useOntologyList(id: number) {
  return useApiQuery<MockObjectItem[]>(
    ['opm-draft', id],
    `/ontologies/${id}/mappable-objects`,
    {
    //   enabled: enabled && !!id,
      staleTime: 0, // 确保每次都从服务器获取最新数据
      retry: 1,
    }
  );
}

// 获取已发布本体对象的语义与数据映射信息
export function useObjectSemanticMapping(objectId: number | string) {
  return useApiQuery<ObjectSemanticMappingResponse>(
    ['semantic-mapping', objectId],
    `/ontologies/objects/${objectId}/semantic-mapping`,
    {
      enabled: !!objectId,
      staleTime: 0,
      retry: 1,
    }
  );
}